<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.87" clip-path="url(#clip0_5416_803866)">
      <path
        d="M4.40541 31.5368C4.82703 31.8456 5.24865 32 5.67027 32C6.09189 32 6.51351 31.8456 6.93513 31.5368L27.7351 18.4125C28.4378 17.9493 29 17.0229 29 15.9421C29 
          14.8613 28.5784 13.9349 27.7351 13.4717L6.93513 0.347407C6.09189 -0.115802 5.10811 -0.115802 4.26486 0.347407C3.56216 0.810615 3 1.73703 3 2.81785V29.0663C3 
          30.1472 3.56216 31.0736 4.40541 31.5368Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5416_803866">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
